import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_INVESTMENT_API_ID = 'INVESTCORE/FETCH_INVESTMENT_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTMENT_API_ID,
  ({ id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/employee-programs/${id}/investment-plans`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
